import { render, staticRenderFns } from "./SafetyStaffManagerment.vue?vue&type=template&id=48b27870&scoped=true"
import script from "./SafetyStaffManagerment.vue?vue&type=script&lang=js"
export * from "./SafetyStaffManagerment.vue?vue&type=script&lang=js"
import style0 from "./SafetyStaffManagerment.vue?vue&type=style&index=0&id=48b27870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b27870",
  null
  
)

export default component.exports